module.exports = __webpack_public_path__ + "static/media/delete.650cdc57.svg";